import { mapGetters } from 'vuex';

import { modalHybrid, navigateParentWindowToFullOPC } from '@/utils/modal-utils.js';
import { planTypes, BASE_PLAN_SUB_TYPES } from '@/common/constants.js';
import { payMethodMap } from '@/views/checkout/payment/helper/constant.js';
import { logger } from '@/utils/log';

export default {
  computed: {
    ...mapGetters([
      'getSelectedPlans',
      'curPaymentMethod',
      'billingInfo',
      'isWithoutCC',
      'isWithCC_ACH_NonAPM',
      'isWithCC',
      'isWithCCByIndia',
      'isWithEWallet',
      'isAPM',
    ]),
    isInModalCheckout() {
      return this.$context.is.modal;
    },
    isInClientModal() {
      return modalHybrid.isInWebview && this.isInModalCheckout;
    },
    isOnlyProPlanInCart() {
      return (
        this.getSelectedPlans.length === 1 &&
        this.getSelectedPlans.find((p) => p.type === planTypes.ZOOM_MEETING && p.category === BASE_PLAN_SUB_TYPES.PRO)
      );
    },
    isFreeTrialInClientModal() {
      // return !this.isInClientModal && this.$context.is.buyTrial && this.isOnlyProPlanInCart;
      return this.isInClientModal && this.$context.is.buyTrial;
    },
  },
  watch: {},
  methods: {
    paymentMethodPreCheckInWebview() {
      logger.log(this.billingInfo);
      logger.log(
        'Modal client: ',
        this.isWithoutCC,
        this.isWithCC_ACH_NonAPM,
        this.isWithCC,
        this.isWithCCByIndia,
        this.isWithEWallet,
        this.curPaymentMethod,
        this.isAPM
      );
      if (modalHybrid.isInWebview) {
        // * only supported payment type in client
        //  * with CC
        //    * ACH(non-APM)
        //    * CC
        //    * 3ds
        if (
          this.isAPM ||
          !(
            this.isWithoutCC ||
            this.isWithCC_ACH_NonAPM ||
            this.isWithCC ||
            this.isWithCCByIndia ||
            this.isWithEWallet
          ) ||
          [payMethodMap.paypal, payMethodMap.apple, payMethodMap.google].includes(this.curPaymentMethod)
        ) {
          // * navigate to full OPC
          navigateParentWindowToFullOPC();
          return false;
        }
      }
      return true;
    },
  },
};
